export default {
    filters: {
        title: "Filtre",
        removeFilter: "Fjern filter",
        filterIntensity: "Filterintensitet",
        duotone: {
            title: "Duoton",
            desert: "Ørken",
            peach: "Fersken",
            clash: "Kollision",
            plum: "Pære",
            breezy: "Lækker",
            deepBlue: "Dybvand-blå",
            frog: "Frø",
            sunset: "Solnedgang",
        },
        blackAndWhite: {
            title: "Sort og Hvid",
            ad: "1920 E.Kr",
            greyed: "Gråtonet",
            dusty: "Støvet",
            litho: "Litho",
            sepia: "Sepia",
            weathered: "Forbrudt",
            hardStuff: "Tungt Stof",
        },
        vintage: {
            title: "Vintage",
            polaroid: "Polaroid",
            sunny: "Solrig 70'erne",
            oldTimer: "Gamle Dage",
            inferno: "Helvede",
            snappy: "Snertfuld",
        },
        smooth: {
            title: "Glat",
            chestnut: "Kastanje",
            softy: "Blødsøgende",
            pebble: "Småsten",
            moss: "Mose",
            lemon: "Citron",
            greenGap: "Grønt Hul",
        },
        cold: {
            title: "Kold",
            colla: "Colla",
            solanus: "Solanus",
            kalmen: "Kalmen",
            jorah: "Joran",
            levante: "Levante",
            zephyr: "Zephyr",
        },
        warm: {
            title: "Varm",
            golden: "Gylden",
            lowFire: "Lavt ild",
            sunrise: "Solopgang",
            flatBack: "Flad Ryg",
            pumpkin: "Græskar",
        },
    },
};
